(() => {
  const questions = '.product-faq .faq-question, .store-faq .faq-question';
  let answerId = 0;

  function updateQuestions() {
    document.querySelectorAll(questions).forEach((question) => {
      const item = question.closest('.faq-item');
      const answer = item?.querySelector('.faq-answer');
      if (!answer) return;
      if (!answer.id) answer.id = `inalash-faq-answer-${++answerId}`;
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-controls', answer.id);
      question.setAttribute('aria-expanded', String(item.classList.contains('active')));
    });
    document.querySelectorAll('.testimonials-dots .dot').forEach((dot, index) => {
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show review ${index + 1}`);
    });
  }

  document.addEventListener('keydown', (event) => {
    const question = event.target.closest(questions);
    if (!question || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    question.click();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest(questions)) updateQuestions();
  });
  document.addEventListener('shopify:section:load', updateQuestions);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateQuestions);
  } else {
    updateQuestions();
  }
})();
